import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var LayoutPrintService = (function () {
    function LayoutPrintService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    LayoutPrintService.prototype.getLayoutPrintList = function (filterParams) {
        var url = this.apiUrl + 'api/cms/layout-print/list';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        return this.http.get(url, { headers: headers, params: params })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    LayoutPrintService.prototype.deleteLayoutPrint = function (id) {
        var url = this.apiUrl + 'api/cms/layout-print/delete/' + id;
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        return this.http.delete(url, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return LayoutPrintService;
}());
export { LayoutPrintService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print/layout-print.service.ts.pre-build-optimizer.js